import React from 'react';
import { styled, Typography } from '@harver/shared-ui';
import { WarningIcon } from '@harver/shared-ui/lib/icons';

import { isValidEmail } from '../../HarverPages/shared/helper';

const DangerTypography = styled(Typography)`
    color: ${({ theme }) => theme.colors.error['500']};
    margin-left: 12px;
    font-size: 15px;
    display: flex;
`;

const CenteredDangerTypography = styled(Typography)`
    color: ${({ theme }) => theme.colors.error['500']};
    font-size: 15px;
    display: flex;
    justify-content: center;
    margin-top: 10px;
`;

const StyledDiamondErrorIcon = styled(WarningIcon)`
    font-size: 20px;
    width: 30px;
    padding-right: 10px;
`;
//TODO - will remove featureToggle param after removing feature toggle - schedulingOpenInviteReCaptcha
export function validate(values, validateError, featureToggle) {
    const errors: any = {};
    if (!values.firstName) {
        errors.firstName = validateError.firstNameRequired;
    }
    if (!values.lastName) {
        errors.lastName = validateError.lastNameRequired;
    }
    if (!values.emailAddress) {
        errors.emailAddress = validateError.emailRequired;
    }
    if (!values.termsAndCondition) {
        errors.termsAndCondition = (
            <>
                <DangerTypography variant="caption">
                    <StyledDiamondErrorIcon />
                    {validateError.termsAndConditionsRequired}
                </DangerTypography>
            </>
        );
    }
    if (values.emailAddress) {
        if (!isValidEmail(values.emailAddress)) {
            errors.emailAddress = validateError.emailInvalid;
        }
    }

    if (!values.recaptchaToken && featureToggle) {
        errors.recaptchaToken = validateError.recaptchaTokenRequired;
    }

    return errors;
}

export const getRecaptchaVerificationFailedError = (validateError) => (
    <>
        <CenteredDangerTypography variant="caption">
            {validateError.recaptchaVerificationFailed}
        </CenteredDangerTypography>
    </>
);
